/**
 * Warm a lazy route chunk only when the user shows intent (hover/focus).
 *
 * Calling the route component factory is the same work the router would do on
 * navigation, but it happens while the pointer is still moving, so the actual
 * click feels instant. Failures are ignored so prefetching can never block a
 * real navigation.
 */
export function prefetchRoute(router, routeName) {
  if (!router || !routeName) return;

  try {
    const resolved = router.resolve({ name: routeName });
    const matched = (resolved && resolved.route && resolved.route.matched) || [];

    matched.forEach((record) => {
      const components = record.components || {};
      Object.keys(components).forEach((key) => {
        const component = components[key];
        if (typeof component === "function") {
          const result = component();
          if (result && typeof result.catch === "function") {
            result.catch(() => {});
          }
        }
      });
    });
  } catch (error) {
    // Prefetching is best-effort.
  }
}
